/* Collection Horizontal Showcase JS — 横方向無限ドリフト + wheel水平変換 + 慣性 */
(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const sections = document.querySelectorAll('.jhshow');
  sections.forEach(initSection);

  function initSection(section) {
    const viewport = section.querySelector('.jhshow__viewport');
    const row = section.querySelector('.jhshow__row');
    if (!viewport || !row) return;

    const baseVelocity = parseFloat(section.dataset.velocity) || -0.6;
    let scrollX = 0;
    let userVel = 0;
    let setWidth = 0;
    let paused = false;
    let inView = false;

    // 1セットの幅を計算（最初の products.length 枚分）
    function measure() {
      const cards = row.children;
      if (cards.length < 2) return;
      // 1セットあたりのカード数 = (全カード) / repeat
      const repeat = parseInt(section.dataset.repeat) || 3;
      const perSet = Math.floor(cards.length / repeat);
      if (perSet < 1) return;
      const a = cards[0].getBoundingClientRect().left;
      const b = cards[perSet].getBoundingClientRect().left;
      setWidth = b - a;
    }

    // hover 時は流れを止める
    section.addEventListener('mouseenter', () => { paused = true; });
    section.addEventListener('mouseleave', () => { paused = false; });

    // IntersectionObserver で画面外時は rAF を停止
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        inView = e.isIntersecting;
        if (inView) requestAnimationFrame(tick);
      });
    }, { threshold: 0.05 });
    io.observe(section);

    // wheel → 水平変換（このセクション上のみ）
    let wheelTimer = null;
    section.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        // 垂直スクロールはそのままページに流す
        return;
      }
      e.preventDefault();
      userVel -= e.deltaX * 0.4;
      paused = true;
      if (wheelTimer) clearTimeout(wheelTimer);
      wheelTimer = setTimeout(() => { paused = false; }, 600);
    }, { passive: false });

    function tick() {
      if (!inView) return;
      if (!paused) {
        scrollX += baseVelocity + userVel;
        userVel *= 0.9;
        if (Math.abs(userVel) < 0.01) userVel = 0;
      } else {
        // pause中もuserVelだけは減衰させる
        scrollX += userVel;
        userVel *= 0.85;
      }
      if (setWidth > 0) {
        while (scrollX <= -setWidth) scrollX += setWidth;
        while (scrollX > 0) scrollX -= setWidth;
      }
      row.style.transform = `translateX(${scrollX}px)`;
      requestAnimationFrame(tick);
    }

    // 起動：フォント・画像ロード後にmeasure
    function start() {
      measure();
      requestAnimationFrame(tick);
    }
    if (document.readyState === 'complete') {
      start();
    } else {
      addEventListener('load', start, { once: true });
    }
    addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
  }
})();
